import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    token: '',
    isLogin: false,
    user: '',
  },
  mutations: {
    set_token(state, token) {
      state.token = token
      sessionStorage.token = token
      // console.log("state" + JSON.stringify(state));
    },
    del_token(state) {
      state.token = ''
      state.isLogin = false
      state.user = ''
      //sessionStorage.removeItem('token');
      sessionStorage.removeItem('isLogin');
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('activePath')
    },
    checkLogin(state, data) {
      sessionStorage.setItem('isLogin', data);
      state.isLogin = data;
    },
    adduser(state, data) {
      sessionStorage.setItem('user', data);
      state.user = data
    }
  },
  getters: {//类似vue.js的计算属性
    getisLogin: state => state.isLogin,
    getuser: state => state.user,
    gettoken: state => state.token
  },
})



// WEBPACK FOOTER //
// ./src/store/store.js